import React, { Component } from "react";
import { Panel } from "react-bootstrap";
import CheckboxRadio from "./CheckboxRadio";
import { Field } from "redux-form";
import arrowUp from "../../../../assets/images/arrow-up.svg";
import arrowDown from "../../../../assets/images/arrow-down.svg";
import styles from "./Accordion.scss";

class Accordion extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showSkills: false,
      count: props.selectedNumber || 0,
      open: false,
      showRadios: props.showRadios || false
    };
  }

  componentWillReceiveProps(nextProps) {
    if (
      this.props.category !== nextProps.category &&
      nextProps.category === nextProps.id
    ) {
      this.setState({
        open: true
      });
    }
    if (this.props.selectedNumber !== nextProps.selectedNumber) {
      this.setState({ count: nextProps.selectedNumber });
    }
  }

  handleCheckbox(skill, checked, event, callback) {
    if (!this.props.handleCheck) return;
    if (checked) {
      this.props.handleCheck(skill, this.state.count + 1, () => {
        this.setState(
          prevState => {
            return { count: prevState.count + 1 };
          },
          () => callback && callback()
        );
      });
    } else {
      this.props.handleCheck(skill, this.state.count - 1, () => {
        this.setState(
          prevState => {
            return { count: prevState.count - 1 };
          },
          () => callback && callback()
        );
      });
    }
  }

  countHandler(formValues, skills) {
    let mustHaves = 0;
    if (formValues != undefined) {
      formValues.map((sk, index) => {
        if (sk != undefined) {
          if (sk.have == "MUST_HAVE") {
            const find = skills.find(function(element) {
              return element.id == index;
            });
            if (find != undefined) {
              mustHaves++;
            }
          }
        }
      });
    }
    return mustHaves;
  }

  render() {
    const count = this.countHandler(
      this.props.selectedSkills,
      this.props.skills
    );
    return (
      <Panel
        eventKey={this.props.id}
        className={styles.panel}
        expanded={this.state.open}
        onToggle={() => {}}
      >
        <Panel.Heading className={styles.panelHeading}>
          <Panel.Title
            toggle
            className={styles.title}
            onClick={() => this.setState({ open: !this.state.open })}
          >
            <div className={styles.titleContainer}>
              <div className={styles.checkboxContainer}>{this.props.name}</div>
              <div className={styles.checkboxContainer}>
                <div className={styles.selected}>
                  {count > 0 ? count + " selected " : ""}
                </div>

                {this.state.open ? (
                  <img src={arrowUp} />
                ) : (
                  <img src={arrowDown} />
                )}
              </div>
            </div>
          </Panel.Title>
        </Panel.Heading>
        <Panel.Body collapsible>
          {this.props.skills &&
            this.props.skills.map(el => {
              return (
                <Field
                  key={el.id}
                  name={`skills[${el.id}]`}
                  onChangeRadio={this.props.onChangeRadio}
                  onCheck={(checked, event, callback) =>
                    this.handleCheckbox(el, checked, event, callback)
                  }
                  text={el.name}
                  category={this.props.category}
                  component={CheckboxRadio}
                  props={{
                    submitting: this.props.submitting,
                    category: this.props.category
                  }}
                  submitting={this.props.submitting}
                  eleId={el.id}
                  defaultValueRadio={this.props.defaultValueRadio}
                  showRadios={this.props.showRadios}
                />
              );
            })}
        </Panel.Body>
      </Panel>
    );
  }
}

export default Accordion;



// WEBPACK FOOTER //
// ./src/routes/employer/project/components/Accordion.js